import gsap from "gsap";
import { scrollTo } from './ScrollLenis';

export default class ScrollNavHighlight {
    constructor(container) {
        this.container = container;
        this.nav = this.container.querySelector('.content-nav');
        this.navItems = this.container.querySelectorAll('.content-nav_item');
        this.backdrop = null;
        this.activeItem = this.container.querySelector('.content-nav_item.active');
        this.hoverTimeline = null;

        this.isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

        this.setupBackdrop();
        this.initListeners();

        if (this.activeItem) {
            this.setBackdropPosition(this.activeItem, false);
            gsap.set(this.backdrop, { autoAlpha: 1 });
        }
    }

    static initAll() {
        document.querySelectorAll('.block-content-nav-a2w').forEach(container => {
            new ScrollNavHighlight(container);
        });
    }

    setupBackdrop() {
        this.backdrop = document.createElement('div');
        this.backdrop.className = 'content-nav_backdrop';
        this.nav.appendChild(this.backdrop);

        gsap.set(this.nav, { position: 'relative' });

        this.navItems.forEach(item => {
            gsap.set(item, { position: 'relative', zIndex: 2 });
        });
    }

    initListeners() {
        this.navItems.forEach(item => {
            item.addEventListener('mouseenter', () => this.handleMouseEnter(item));
            item.addEventListener('mouseleave', () => this.handleMouseLeave(item));
            item.addEventListener('click', (e) => this.handleClick(item, e));
        });
    }

    async handleClick(item, event) {
        event.preventDefault();

        // Gérer les classes actives
        this.navItems.forEach(el => el.classList.remove('active'));
        item.classList.add('active');
        this.activeItem = item;

        // Animation douce du backdrop
        await gsap.to(this.backdrop, {
            ...this.getItemRect(item),
            duration: 0.3,
            ease: "power2.out"
        });

        // Scroll une fois l’animation terminée
        const href = item.getAttribute('href');
        if (href && href.startsWith('#')) {
            const targetEl = document.querySelector(href);
            if (targetEl) {
                const header = document.querySelector('.site-header');
                const offset = header ? -header.offsetHeight : -100;

                scrollTo(targetEl, {
                    offset: offset,
                    duration: 1.2,
                    easing: t => Math.min(1, 1.001 - Math.pow(2, -10 * t))
                });
            }
        }
    }

    handleMouseEnter(item) {
        if (this.isTouchDevice || item === this.activeItem) return;
        this.animateBackdrop(item);
    }

    handleMouseLeave(item) {
        if (this.isTouchDevice || item !== this.activeItem) {
            this.animateBackdrop(this.activeItem);
        }
    }

    setBackdropPosition(item, animated = true) {
        const props = this.getItemRect(item);

        animated
            ? gsap.to(this.backdrop, { ...props, duration: 0.4, ease: "power2.out" })
            : gsap.set(this.backdrop, props);
    }

    animateBackdrop(item) {
        if (!item) return;

        const props = this.getItemRect(item);

        gsap.to(this.backdrop, {
            ...props,
            duration: 0.3,
            ease: "back.out(1.4)"
        });
    }

    getItemRect(item) {
        const rect = item.getBoundingClientRect();
        const navRect = this.nav.getBoundingClientRect();
        const offsetLeft = rect.left - navRect.left + this.nav.scrollLeft;

        return {
            x: offsetLeft,
            width: rect.width,
            height: rect.height,
            borderRadius: "500px"
        };
    }
}
